import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import CONSTANTS from '../utils/Constants';
import InvisibleCaptcha from '../components/InvisibleCaptcha';
import withRouter from '../utils/withRouter';

const CenterText = styled('div')({
	textAlign: "center"
});

const VerticalCenter = styled('div')({
	margin: 0,
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)"
});

const Screen = styled('div')(({ theme, category }) => ({
	display: "inline-block",
	position: "fixed",
	top: 0,
	bottom: 0,
	left: 0,
	right: 0,
	margin: "auto",
	paddingLeft: theme.spacing(3.5),
	paddingRight: theme.spacing(3.5),
	backgroundColor: category === 'positive' ? CONSTANTS.COLORS.POSITIVE :
					 category === 'uncertain' ? CONSTANTS.COLORS.UNCERTAIN :
					 category === 'negative' ? CONSTANTS.COLORS.NEGATIVE :
					 category === 'tip' ? CONSTANTS.COLORS.TIP :
					 theme.palette.background.default,
}));

const GapButton = styled(Button)(({ theme }) => ({
	marginTop: "32vh",
	marginBottom: "2vh",
}));

const Heading = styled(Typography)(({ theme }) => ({
	paddingBottom: "5vh",
	fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
	fontSize: theme.spacing(3),
	fontWeight: 900
}));

const PrimaryTextColor = {
	borderColor: CONSTANTS.COLORS.WHITE,
	color: CONSTANTS.COLORS.WHITE,
};

class Thanks extends Component {
	constructor(props, context) {
		super(props, context);
		
		this.state = {
			recaptchaToken: null
		}
	}

	onCloseTap = () => {
		const {messageSource} = this.props;

		if(messageSource) {
			messageSource.postMessage({
				type: "APP_CONTROL",
				action: "close"
			}, "*");
		}
		// Still want to go back in case someone posts again without reloading
		setTimeout(() => this.props.history.goBack(), 250);
	}
	
	onRecaptchaChange = token => {
		console.log("New token: ", token.length);
		this.setState({recaptchaToken: token});
	}

	render() {
		let {match, isMobile, locationContact} = this.props;
		// fallback on tip if no category
		let category = match.params.category || 'tip';
		let items = [
			(
				<Heading
					key="heading"
					sx={PrimaryTextColor}
					color="primary"
					variant="h5"
				>
					Thank You.
				</Heading>
			)
		];
		
		const showContact = isMobile && locationContact;

		if(showContact) {
			items = items.concat([
				(
					<Typography
						key="contact-prompt"
						sx={PrimaryTextColor}
						color="primary"
						variant="h6"
					>
						Would you like to talk to someone now?
					</Typography>
				),(
					<GapButton 
						key="call-button"
						fullWidth={true}
						variant="outlined"
						size="large"
						href={`tel:${locationContact}`}
						color="primary"
						aria-label="talk to counselor"
						ga-on="click"
						ga-event-category="WebApp"
						ga-event-action="Button Pressed"
						ga-event-label="Call Someone"
						sx={{
							'&.MuiButton-outlinedPrimary': PrimaryTextColor,
						}}
					>
						Yes
					</GapButton>
				)
			]);
		}
		
		const label = showContact ? "No thanks" : "Close";
		const trackLabel = showContact ? "Skip Call Someone" : "Close";
		items.push((
			<Button
				key="close-button"
				color="primary"
				aria-label="skip talk to counselor"
				ga-on="click"
				ga-event-category="WebApp"
				ga-event-action="Button Pressed"
				ga-event-label={trackLabel}
				sx={{
					'&.MuiButton-textPrimary': PrimaryTextColor,
				}}
				onClick={this.onCloseTap}
			>
				{label}
			</Button>
		))

		return (
			<Screen category={category}>
				<VerticalCenter>
					<Grid container 
						direction="column" 
						alignItems="center"
						spacing={2}>
						{
							items.map((component, idx) => (
								<Grid key={idx} item>
									<CenterText>
										{component}
									</CenterText>
								</Grid>
							))
						}
					</Grid>
				</VerticalCenter>
				<InvisibleCaptcha
					action={`thanks_${category}`}
					verifyCallback={this.onRecaptchaChange}
				/>
			</Screen>
		);
	}
}

Thanks.propTypes = {
	match: PropTypes.object.isRequired,
	messageSource: PropTypes.object,
	locationContact: PropTypes.string,
	isMobile: PropTypes.bool,
	history: PropTypes.object.isRequired
};

export default withRouter(Thanks);